import React from "react";
import Loader from "../../Loader";
import PageContent from "./PageContent";

const SignupSuccess = () => {
	return (
		<>
			<Loader />
			<PageContent />
		</>
	);
};
export default SignupSuccess;
